import { getTranslation } from '../../../../utils/translations';
import translation from './translations';
import { MARITAL_STATUSES } from './formModel.types';
var t = getTranslation(translation);
var applicantsCountOptions = [
    { label: t.oneApplicant, value: 1 },
    { label: t.twoApplicants, value: 2 },
];
var isSameHouseholdOptions = [
    { label: t.yes, value: true },
    { label: t.no, value: false },
];
var maritalStatusOptions = [
    { label: t.maritalStatus_no_value, value: undefined },
    {
        label: t.maritalStatus_married,
        value: MARITAL_STATUSES.MARRIED,
    },
    {
        label: t.maritalStatus_partnership,
        value: MARITAL_STATUSES.PARTNERSHIP,
    },
    {
        label: t.maritalStatus_separated,
        value: MARITAL_STATUSES.SEPARATED,
    },
    {
        label: t.maritalStatus_divorced,
        value: MARITAL_STATUSES.DIVORCED,
    },
];
export default {
    applicantsCountOptions: applicantsCountOptions,
    isSameHouseholdOptions: isSameHouseholdOptions,
    maritalStatusOptions: maritalStatusOptions,
};
